/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ raceDate: NonNullable<unknown>, daysToRace: NonNullable<unknown> }} Coach_Rationale_TaperInputs */

const en_coach_rationale_taper = /** @type {(inputs: Coach_Rationale_TaperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Taper plan for race on ${i?.raceDate}. ${i?.daysToRace} days to race.`)
};

const de_coach_rationale_taper = /** @type {(inputs: Coach_Rationale_TaperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Taper-Plan für den Wettkampf am ${i?.raceDate}. Noch ${i?.daysToRace} Tage bis zum Start.`)
};

/**
* | output |
* | --- |
* | "Taper plan for race on {raceDate}. {daysToRace} days to race." |
*
* @param {Coach_Rationale_TaperInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_rationale_taper = /** @type {((inputs: Coach_Rationale_TaperInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Rationale_TaperInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_rationale_taper(inputs)
	return de_coach_rationale_taper(inputs)
});